import React from "react";
import { Trash2 } from "lucide-react";
import LinkIcon from "../ui/LinkIcon";
import DragHandle from "./DragHandle";
import IconSelect from "./IconSelect";

// Editor row for a social link: icon preview, title, icon picker and URL.
// `compact` is the stacked mobile layout; the default is the single-line desktop layout.
const SocialLinkRow = ({
  input,
  index,
  onChange,
  onLinkBlur,
  onRemove,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop,
  dragging,
  compact,
  t,
}) => (
  <div
    onDragOver={onDragOver}
    onDrop={(event) => onDrop(event, index)}
    className={
      "flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl " +
      (compact ? "p-3" : "p-2.5") +
      " focus-within:border-indigo-400 focus-within:ring-2 focus-within:ring-indigo-100 transition " +
      (dragging ? "opacity-40" : "")
    }
  >
    <DragHandle index={index} onDragStart={onDragStart} onDragEnd={onDragEnd} t={t} />
    <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex items-center justify-center shrink-0">
      <LinkIcon value={input.image || "fa-link text-slate-300"} className="text-base sm:text-lg" />
    </div>
    {compact ? (
      <div className="flex-1 min-w-0 space-y-1.5">
        <input
          required
          placeholder={t("Link Title")}
          className="w-full bg-transparent border-0 p-0 focus:outline-none focus:ring-0 text-sm font-medium text-slate-700 placeholder:text-slate-400"
          name="social_name"
          value={input.social_name}
          onChange={(event) => onChange(index, event)}
        ></input>
        <div className="flex items-center gap-2">
          <IconSelect
            className="shrink-0 bg-white border border-slate-200 rounded-lg text-xs px-2 py-1.5 text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-200"
            value={input.image}
            onChange={(event) => onChange(index, event)}
            t={t}
          />
          <input
            required
            name="link"
            placeholder={t("Link")}
            className="min-w-0 flex-1 bg-transparent border-0 p-0 focus:outline-none focus:ring-0 text-xs text-slate-500 placeholder:text-slate-400"
            onChange={(event) => onChange(index, event)}
            onBlur={() => onLinkBlur(index)}
            value={input.link}
          ></input>
        </div>
      </div>
    ) : (
      <>
        <input
          required
          placeholder={t("Link Title")}
          className="min-w-0 basis-32 grow-0 shrink-0 bg-transparent border-0 focus:outline-none focus:ring-0 text-sm font-medium text-slate-700 placeholder:text-slate-400"
          name="social_name"
          value={input.social_name}
          onChange={(event) => onChange(index, event)}
        ></input>
        <IconSelect
          className="shrink-0 bg-white border border-slate-200 rounded-lg text-xs px-2 py-2 text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-200"
          value={input.image}
          onChange={(event) => onChange(index, event)}
          t={t}
        />
        <input
          required
          name="link"
          placeholder={t("Link")}
          className="min-w-0 flex-1 bg-transparent border-0 focus:outline-none focus:ring-0 text-sm text-slate-500 placeholder:text-slate-400"
          onChange={(event) => onChange(index, event)}
          onBlur={() => onLinkBlur(index)}
          value={input.link}
        ></input>
      </>
    )}
    <button
      type="button"
      className={
        (compact ? "self-start " : "") +
        "shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-slate-300 hover:text-red-500 hover:bg-red-50 transition"
      }
      onClick={() => {
        onRemove(index);
      }}
    >
      <Trash2 className="w-4 h-4" />
    </button>
  </div>
);

export default SocialLinkRow;
